export const PollsConstants = Object.freeze({
    polls:"polls",
    post:"POST",
    v2_create:"v2/create",
    v2_vote:"v2/vote",
    extension_poll:"extension_poll",
    injected:"@injected"
})